export const stripLocale = (path: string, locale: string) =>
  path.replace(new RegExp(`^/${locale}(/.*)?$`), '$1');
